import { api } from "@/lib/api";

export const customersApi = {
  meta: () => api.get("/customers/meta").then((r) => r.data),
  stats: () => api.get("/customers/stats").then((r) => r.data),
  list: (params) => api.get("/customers", { params }).then((r) => r.data),
  get: (id) => api.get(`/customers/${id}`).then((r) => r.data),
  create: (body) => api.post("/customers", body).then((r) => r.data),
  update: (id, body) => api.put(`/customers/${id}`, body).then((r) => r.data),
  setStatus: (id, status) => api.patch(`/customers/${id}/status`, { status }).then((r) => r.data),
  enquiries: (id) => api.get(`/customers/${id}/enquiries`).then((r) => r.data),
  linkEnquiries: (id) => api.post(`/customers/${id}/link-enquiries`).then((r) => r.data),
};

export const CUST_STATUS_STYLE = {
  Active: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Inactive: "bg-rose-50 text-rose-700 border border-rose-200",
};
